module.exports = __webpack_public_path__ + "fonts/Raleway-ExtraBold.92aee672.ttf";